import "./SponsorImg.css";

const SponsorImg = ({ sponsor }) => {
	return (
		<div className={`SponsorCard ${sponsor.type}`}>
			<a href={sponsor.url} target="_blank" rel="noopener noreferrer">
				<div
					className="SponsorCardImg"
					style={{ backgroundImage: `url(${sponsor.img})` }}
				></div>
				<div className="SponsorCardTitle">
					<h5>{sponsor.name}</h5>
				</div>
			</a>
		</div>
	);
};

export default SponsorImg;
